import React, { useState, useEffect, useRef, useCallback } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { closeModal } from "../../../../redux/actions/action-creator";
import { Link } from 'react-router-dom';

const SummaryType = (props) => {
  const dispatch = useDispatch();

  const [all_data, setAllData] = useState([
    { id: 'group_wise', name: 'Group-Wise' },
    { id: 'category_wise', name: 'Category-Wise' },
    { id: 'company_wise', name: 'Company-Wise' },
    { id: 'item_wise', name: 'Item-Wise' },
  ]);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedItem, setSelectedItem] = useState(0);
  const containerRef = useRef(null);
  const searchInputRef = useRef(null);

  useEffect(() => {
    if (props.setLoading) {
      props.setLoading(false);
    }
  }, []);

  const filteredData = all_data.filter(item =>
    item.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  useEffect(() => {
    setSelectedItem(0);
  }, [searchQuery]);

  // Scroll into view helper
  useEffect(() => {
    if (containerRef.current) {
      const selectedElement = containerRef.current.querySelector('.selected');
      if (selectedElement) {
        const containerHeight = containerRef.current.offsetHeight;
        const elementTop = selectedElement.offsetTop - containerRef.current.offsetTop;
        const elementBottom = elementTop + selectedElement.offsetHeight;
        
        if (elementTop < containerRef.current.scrollTop) {
          containerRef.current.scrollTop = elementTop;
        } else if (elementBottom > containerRef.current.scrollTop + containerHeight) {
          containerRef.current.scrollTop = elementBottom - containerHeight;
        }
      }
    }
  }, [selectedItem]);

  const handleKeyDown = useCallback((e) => {
    if (e.key === 'ArrowUp') {
      e.preventDefault();
      setSelectedItem(prevState => Math.max(prevState - 1, 0));
    } else if (e.key === 'ArrowDown') {
      e.preventDefault();
      setSelectedItem(prevState => Math.min(prevState + 1, filteredData.length - 1));
    } else if (e.key === 'Enter') {
      e.preventDefault();
      const selected = filteredData[selectedItem];
      if (selected) {
        props.setDate({ ...props.date, filter_name: selected.name });
        dispatch(closeModal('summaryType'));
      }
    } else if (e.key === 'Escape') {
      e.preventDefault();
      dispatch(closeModal('summaryType'));
      e.stopPropagation();
    }
  }, [selectedItem, filteredData, dispatch, props.date, props.setDate]);

  const handleWheel = useCallback((e) => {
    e.preventDefault();
    if (e.deltaY < 0) {
      setSelectedItem(prevState => Math.max(prevState - 1, 0));
    } else if (e.deltaY > 0) {
      setSelectedItem(prevState => Math.min(prevState + 1, filteredData.length - 1));
    }
  }, [filteredData.length]);

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    window.addEventListener('wheel', handleWheel, { passive: false });
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('wheel', handleWheel);
    };
  }, [handleKeyDown, handleWheel]);

  return (
    <div className='my-card'>
      <div className='cross_button' onClick={() => dispatch(closeModal('summaryType'))}>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x" viewBox="0 0 16 16">
          <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
        </svg>
      </div>
      <div className='container'>
        <div className="row justify-content-center mt-4">
          <div className='col-4 border bg-light border-dark' ref={containerRef} style={{ height: '300px', overflowY: 'auto' }}>
            <div className='row background' style={{ height: 30 }}>
              <div className='col-12 text-center'>
                <p className='m-0'>Summary Type</p>
              </div>
            </div>
            <div className='row ps-1 pe-1 pt-1' style={{ height: 25 }}>
              <input
                autoFocus
                autoComplete="off"
                className='voucher_entry_account_input'
                type="text"
                id='search_input'
                name='search_input'
                style={{ margin: 0, padding: 0, paddingLeft: 5, width: '100%' }}
                onChange={(e) => setSearchQuery(e.target.value)}
                ref={searchInputRef}
                value={searchQuery} />
            </div>
            <div className='row mt-1 border-top border-secondary'>
              {filteredData.length > 0 ? (
                filteredData.map((item, index) => {
                  const name = item.name;
                  const matchIndex = name.toLowerCase().indexOf(searchQuery.toLowerCase());
                  return (
                    <div
                      className={`col-12 p-1 dropdown_link ${index === selectedItem ? 'selected' : ''}`}
                      key={item.id}
                      onClick={() => {
                        setSelectedItem(index);
                        props.setDate({ ...props.date, filter_name: item.name });
                        dispatch(closeModal('summaryType'));
                      }}
                    >
                      <Link className="ps-2" style={{ textDecoration: 'none', color: 'inherit' }}>
                        {matchIndex !== -1 && searchQuery !== '' ? (
                          <>
                            {name.substring(0, matchIndex)}
                            <span style={{ color: 'red' }}>{name.substring(matchIndex, matchIndex + searchQuery.length)}</span>
                            {name.substring(matchIndex + searchQuery.length)}
                          </>
                        ) : (
                          name
                        )}
                      </Link>
                    </div>
                  );
                })
              ) : (
                <p className="ps-2 pt-2" style={{ color: 'red' }}>No matching items found</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SummaryType;